import { useState } from "react";
import "./Subtitle.css";

const titles = {
  fire4: (t) => {
    const amount = Math.floor(t / 2.8);

    return (
      <p>
        That's <code>{amount}</code> Fire IVs.
      </p>
    );
  },
  gcd: (t) => {
    const amount = Math.floor(t / 2.5);

    return (
      <p>
        That's <code>{amount}</code> GCDs.
      </p>
    );
  },
  prae: (t) => {
    const time = 38 * 60 + 68;
    const amount = Math.floor(t / time);

    return (
      <p>
        That's <code>{amount}</code>
        {" " /* fucking prettier i swear */}
        <a href="https://www.speedrun.com/ffxiv/run/z1rrrl7m">
          runs of The Praetorium.
        </a>
      </p>
    );
  },
  antitower: (t) => {
    const time = 6 * 60 + 7;
    const amount = Math.floor(t / time);

    return (
      <p>
        That's <code>{amount}</code>
        {" " /* fucking prettier i swear */}
        <a href="https://www.speedrun.com/ffxiv/run/yjlw77oz">
          runs of The Antitower.
        </a>
      </p>
    );
  },
  egg: (t) => {
    const time = 30 * 60;
    const amount = Math.floor(t / time);

    return (
      <p>
        That's <code>{amount}</code> food buffs.
      </p>
    );
  },
  sprint: (t) => {
    const amount = Math.floor(t / 60);

    return (
      <p>
        That's <code>{amount}</code> Sprints.
      </p>
    );
  },
  heatblast: (t) => {
    const amount = Math.floor(t / 1.5);

    return (
      <p>
        That's <code>{amount}</code> Heat Blasts.
      </p>
    );
  },
  sub: (t) => {
    const worthPerSecond =
      12.99 / // entry sub cost
      30 / // days
      24 / // hours
      60 / // minutes
      60; // second
    const amount = (t * worthPerSecond).toFixed(3);

    return (
      <p>
        That's <code>${amount}</code> worth of a sub.
      </p>
    );
  },
  lb3: (t) => {
    const amount = Math.floor(t / 4.5);

    return (
      <p>
        That's <code>{amount}</code> DPS LB3s.
      </p>
    );
  },
  raise: (t) => {
    const amount = Math.floor(t / 8);

    return (
      <p>
        That's <code>{amount}</code> hard casted Raises.
      </p>
    );
  },
  lily: (t) => {
    const amount = Math.floor(t / 30);

    return (
      <p>
        That's <code>{amount}</code> Lilies.
      </p>
    );
  },
  bloodlily: (t) => {
    const amount = Math.floor(t / 90);

    return (
      <p>
        That's <code>{amount}</code> Blood Lilies.
      </p>
    );
  },
  bolide: (t) => {
    const amount = Math.floor(t / 360);

    return (
      <p>
        That's <code>{amount}</code> Superbolides.
      </p>
    );
  }
};

const releaseText = (
  <p>
    Go play it!
    <br />
    <a href="https://na.finalfantasyxiv.com/endwalker/">Buy Endwalker</a>
    <br />
    <a href="steam://run/39210">Steam</a>
    <br />
    <a href="https://sqex.to/ffxiv_client_en">Official Launcher</a>
    <br />
    <a href="https://github.com/goatcorp/FFXIVQuickLauncher">XIVLauncher</a>
  </p>
);

function pickRandom(filter) {
  let funcs = Object.keys(titles);
  if (filter) funcs = funcs.filter((x) => x !== filter);
  return funcs[Math.floor(Math.random() * funcs.length)];
}

export default function Subtitle(props) {
  const [title, setTitle] = useState(pickRandom());

  const timeLeft = Math.floor(props.t / 1000);
  if (timeLeft <= 0) return releaseText;

  function buttonClick() {
    setTitle(pickRandom(title));
  }

  const titleFunc = titles[title];
  return (
    <div>
      {titleFunc(timeLeft)}
      <button onClick={buttonClick} class="Subtitle-button">
        (show another one)
      </button>
    </div>
  );
}
